import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_PROVEEDORES_URL } from '../../constants';
import { Container, Form, Col, Button, Table } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import './Encuesta.css';

function EncuestaSatisfaccion(props) {
    const idEncuesta = props.match.params.idEncuesta;
    const [encuesta, setEncuesta] = useState(null);
    const [campos, setCampos] = useState(null);
    const [respuestas, setRespuestas] = useState({});
    const [enviado, setEnviado] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [yaRespondida, setYaRespondida] = useState(false);
    const [respuestasGuardadas, setRespuestasGuardadas] = useState(null);

    useEffect(() => { getEncuesta(); }, []);

    function getEncuesta() {
        axios.post(API_PROVEEDORES_URL + 'encuesta/get', { idEncuesta })
            .then((res) => {
                setLoading(false);
                if (res.data.result.code === 200 && res.data.encuesta) {
                    setEncuesta(res.data.encuesta);
                    if (res.data.campos) {
                        setCampos(typeof res.data.campos === 'string' ? JSON.parse(res.data.campos) : res.data.campos);
                    }
                    if (res.data.respondida) {
                        setYaRespondida(true);
                        if (res.data.respuestas) {
                            setRespuestasGuardadas(typeof res.data.respuestas === 'string' ? JSON.parse(res.data.respuestas) : res.data.respuestas);
                        }
                    }
                } else {
                    setError('La encuesta solicitada no existe o el enlace no es válido.');
                }
            }).catch(() => { setLoading(false); setError('Error al conectar con el servidor.'); });
    }

    function handleRespuesta(id, valor) {
        setRespuestas(prev => ({ ...prev, [id]: valor }));
    }

    function enviarRespuesta(e) {
        e.preventDefault();
        // Validar que todas las preguntas tengan respuesta
        if (campos && campos.secciones) {
            for (const seccion of campos.secciones) {
                for (const pregunta of seccion.preguntas) {
                    if (!respuestas[pregunta.id]) {
                        toast.error('Por favor responda todas las preguntas', { position: 'top-center' });
                        return;
                    }
                }
            }
        }
        axios.post(API_PROVEEDORES_URL + 'encuesta/responder', { idEncuesta, respuestas })
            .then((res) => {
                if (res.data.result.code === 200) { setEnviado(true); }
                else { toast.error(res.data.result.message, { position: 'top-center' }); }
            }).catch(() => { toast.error('Error al enviar la respuesta', { position: 'top-center' }); });
    }

    function renderPregunta(pregunta) {
        if (pregunta.tipo === 'si_no_na') {
            return (
                <div className="encuesta-opciones" key={pregunta.id}>
                    {['SI', 'NO', 'N/A'].map(op => (
                        <Form.Check key={op} inline type="radio" label={op} name={pregunta.id}
                            checked={respuestas[pregunta.id] === op}
                            onChange={() => handleRespuesta(pregunta.id, op)} />
                    ))}
                </div>
            );
        } else if (pregunta.tipo === 'si_no') {
            return (
                <div className="encuesta-opciones" key={pregunta.id}>
                    {['SI', 'NO'].map(op => (
                        <Form.Check key={op} inline type="radio" label={op} name={pregunta.id}
                            checked={respuestas[pregunta.id] === op}
                            onChange={() => handleRespuesta(pregunta.id, op)} />
                    ))}
                </div>
            );
        } else if (pregunta.tipo === 'escala') {
            return (
                <div className="encuesta-opciones" key={pregunta.id}>
                    {(pregunta.opciones || []).map(op => (
                        <Form.Check key={op} inline type="radio" label={op} name={pregunta.id}
                            checked={respuestas[pregunta.id] === op}
                            onChange={() => handleRespuesta(pregunta.id, op)} />
                    ))}
                </div>
            );
        }
        return null;
    }

    if (loading) return <Container className="encuesta-container"><p>Cargando...</p></Container>;
    if (error) return <Container className="encuesta-container"><div className="encuesta-card"><h2>Enlace no válido</h2><p className="text-danger">{error}</p></div></Container>;

    if (yaRespondida) {
        return (
            <Container className="encuesta-container">
                <div className="encuesta-gracias">
                    <h2>Encuesta ya respondida</h2>
                    <p>Esta encuesta fue respondida el <b>{encuesta.fechaRespuesta}</b>.</p>
                    <p>¡Gracias por su participación!</p>
                </div>
            </Container>
        );
    }

    if (enviado) {
        return (
            <Container className="encuesta-container">
                <div className="encuesta-gracias">
                    <h2>¡Gracias por su opinión!</h2>
                    <p>Su respuesta ha sido registrada exitosamente.</p>
                </div>
            </Container>
        );
    }

    return (
        <Container className="encuesta-container">
            <ToastContainer />
            <div className="encuesta-card">
                {campos && <>
                    <h2>{campos.titulo}</h2>
                    {campos.subtitulo && <p className="encuesta-subtitulo">{campos.subtitulo}</p>}
                    <p><b>Fecha:</b> {new Date().toLocaleDateString()}</p>
                    <p><b>Proveedor:</b> {encuesta.proveedor}</p>
                    <p><b>Empresa:</b> {encuesta.empresa}</p>
                    <hr />

                    <Form onSubmit={enviarRespuesta}>
                        {campos.secciones.map((seccion, idx) => (
                            <div key={idx} className="encuesta-seccion">
                                <h4>{seccion.nombre}</h4>
                                <Table bordered hover size="sm">
                                    <thead>
                                        <tr>
                                            <th>Criterio</th>
                                            <th>Resultado</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {seccion.preguntas.map(pregunta => (
                                            <tr key={pregunta.id}>
                                                <td>{pregunta.texto}</td>
                                                <td>{renderPregunta(pregunta)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                {seccion.comentarios && (
                                    <Form.Group>
                                        <Form.Label><b>Comentarios:</b></Form.Label>
                                        <Form.Control as="textarea" rows={3}
                                            placeholder={seccion.comentarios.placeholder || ''}
                                            value={respuestas[seccion.comentarios.id] || ''}
                                            onChange={(e) => handleRespuesta(seccion.comentarios.id, e.target.value)} />
                                    </Form.Group>
                                )}
                            </div>
                        ))}
                        <Button type="submit" className="btn-encuesta-enviar">Enviar respuesta</Button>
                    </Form>
                </>}
            </div>
        </Container>
    );
}

export default EncuestaSatisfaccion;
